(function () {
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return (format || '{{amount}}').replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return withCommas;
      if (key === 'amount_with_comma_separator') return withCommas.replace(/,/g, '.') + ',' + parts[1];
      if (key === 'amount_no_decimals_with_comma_separator') return withCommas.replace(/,/g, '.');
      return withCommas + '.' + parts[1];
    });
  }

  function formatShort(cents, format) {
    return formatMoney(cents, format).replace(/[.,]00(?!\d)/, '');
  }

  function fill(template, map) {
    return (template || '').replace(/\[(\w+)\]/g, function (match, key) {
      return Object.prototype.hasOwnProperty.call(map, key) ? map[key] : match;
    });
  }

  function parseJSON(el, fallback) {
    try {
      return el ? JSON.parse(el.textContent) : fallback;
    } catch (e) {
      return fallback;
    }
  }

  var ICON_PLUS = '<svg width="20" height="20" viewBox="0 0 20 20" fill="currentColor"><path d="M15.833 10.834h-5v5H9.166v-5h-5V9.167h5v-5h1.667v5h5v1.667Z"/></svg>';
  var ICON_X = '<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function Byob(root) {
    this.root = root;
    this.data = root.dataset;
    this.moneyFormat = this.data.moneyFormat || '{{amount}}';
    this.maxPerProduct = parseInt(this.data.maxPerProduct, 10) || 99;
    this.tiers = parseJSON(root.querySelector('[data-byob-tiers]'), [])
      .filter(function (t) { return t.quantity > 0; })
      .sort(function (a, b) { return a.quantity - b.quantity; });
    this.products = {};
    var list = parseJSON(root.querySelector('[data-byob-products]'), []);
    for (var i = 0; i < list.length; i++) this.products[list[i].id] = list[i];
    this.items = [];
    this.activeTier = 0;
    this.busy = false;
    this.panel = root.querySelector('[data-byob-panel]');
    if (!this.panel) return;
    this.qvModal = root.querySelector('[data-byob-quickview-modal]');
    this.vdModal = root.querySelector('[data-byob-variant-drawer]');
    this.toastEl = root.querySelector('[data-byob-toast]');
    this.ctaLabelEl = root.querySelector('[data-byob-cta-label]');
    this.ctaDefault = this.ctaLabelEl ? this.ctaLabelEl.textContent : '';
    document.body.appendChild(this.qvModal);
    document.body.appendChild(this.vdModal);
    this.copyVars();
    this.renderTiers();
    this.bind();
    this.render();
  }

  Byob.prototype.copyVars = function () {
    var cs = getComputedStyle(this.root);
    var names = ['--byob-font', '--byob-text', '--byob-btn-bg', '--byob-btn-text', '--byob-card-outline-active', '--byob-btn-radius'];
    [this.qvModal, this.vdModal, this.toastEl].forEach(function (el) {
      if (!el) return;
      names.forEach(function (n) { el.style.setProperty(n, cs.getPropertyValue(n)); });
    });
  };

  Byob.prototype.tier = function () {
    return this.tiers[this.activeTier] || null;
  };

  Byob.prototype.maxItems = function () {
    return this.tiers.length ? this.tiers[this.tiers.length - 1].quantity : Infinity;
  };

  Byob.prototype.renderTiers = function () {
    var self = this;
    var html = this.tiers.map(function (t, i) {
      var price = formatShort(t.price, self.moneyFormat);
      return '<button type="button" class="byob-tier" data-byob-tier="' + i + '">' +
        '<span class="byob-tier__heading">' + fill(self.data.textTierHeading, { quantity: t.quantity, price: price }) + '</span>' +
        '<span class="byob-tier__sub">' + fill(self.data.textTierSubtext, { quantity: t.quantity, price: price }) + '</span>' +
        '</button>';
    }).join('');
    this.root.querySelectorAll('[data-byob-tiers-wrap]').forEach(function (wrap) {
      wrap.innerHTML = html;
      wrap.style.setProperty('--byob-tier-count', Math.max(self.tiers.length, 1));
    });
  };

  Byob.prototype.bind = function () {
    var self = this;

    this.root.addEventListener('click', function (e) {
      var t = e.target;
      var tierBtn = t.closest('[data-byob-tier]');
      if (tierBtn) return self.selectTier(parseInt(tierBtn.dataset.byobTier, 10));

      var card = t.closest('[data-byob-card]');
      var pid = card ? parseInt(card.dataset.productId, 10) : null;

      if (t.closest('[data-byob-add]') || t.closest('[data-byob-plus]')) return self.requestAdd(pid);
      if (t.closest('[data-byob-minus]')) return self.removeLastOf(pid);
      if (t.closest('[data-byob-quickview]')) return self.openQuickView(pid);

      var removeBtn = t.closest('[data-byob-remove]');
      if (removeBtn) return self.removeAt(parseInt(removeBtn.dataset.byobRemove, 10));

      if (t.closest('[data-byob-clear]')) {
        self.items = [];
        self.activeTier = 0;
        return self.render();
      }
      if (t.closest('[data-byob-toggle]')) return self.setPanelOpen(!self.panel.classList.contains('is-open'));
      if (t.closest('[data-byob-submit]')) return self.submit();

      if (card && card.dataset.productUrl && !t.closest('a, button, [data-byob-qty]')) {
        window.location.href = card.dataset.productUrl;
      }
    });

    this.root.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.matches('[data-byob-quickview][role="button"]')) {
        e.preventDefault();
        var card = e.target.closest('[data-byob-card]');
        self.openQuickView(parseInt(card.dataset.productId, 10));
      }
    });

    [this.qvModal, this.vdModal].forEach(function (modal) {
      modal.addEventListener('click', function (e) {
        if (e.target.closest('[data-byob-close]')) self.closeModal(modal);
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      self.closeModal(self.qvModal);
      self.closeModal(self.vdModal);
    });

    this.qvModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-byob-qv-prev]')) self.showImage(self.qvIndex - 1);
      if (e.target.closest('[data-byob-qv-next]')) self.showImage(self.qvIndex + 1);
      var thumb = e.target.closest('[data-byob-qv-thumb]');
      if (thumb) self.showImage(parseInt(thumb.dataset.byobQvThumb, 10));
    });

    this.vdModal.addEventListener('click', function (e) {
      var val = e.target.closest('[data-byob-opt]');
      if (val) {
        self.vdSelection[parseInt(val.dataset.byobOpt, 10)] = val.dataset.value;
        return self.renderVariantOptions();
      }
      if (e.target.closest('[data-byob-vd-add]')) {
        var v = self.currentVariant();
        if (!v || !v.available) return;
        if (self.add(self.vdProduct.id, v.id)) self.closeModal(self.vdModal);
      }
    });
  };

  Byob.prototype.countOf = function (pid) {
    return this.items.filter(function (it) { return it.productId === pid; }).length;
  };

  Byob.prototype.requestAdd = function (pid) {
    var product = this.products[pid];
    if (!product) return;
    var available = product.variants.filter(function (v) { return v.available; });
    if (!available.length) return;
    if (!this.canAdd(pid)) return;
    if (product.variants.length > 1 && this.data.skipVariantPicker !== 'true') return this.openVariantDrawer(product);
    this.add(pid, available[0].id);
  };

  Byob.prototype.canAdd = function (pid) {
    if (this.items.length >= this.maxItems()) {
      this.toast(this.data.textMax);
      return false;
    }
    if (this.countOf(pid) >= this.maxPerProduct) {
      this.toast(this.data.textMax);
      return false;
    }
    return true;
  };

  Byob.prototype.add = function (pid, vid) {
    if (!this.canAdd(pid)) return false;
    this.items.push({ productId: pid, variantId: vid });
    var tier = this.tier();
    if (tier && this.items.length > tier.quantity) {
      for (var i = 0; i < this.tiers.length; i++) {
        if (this.tiers[i].quantity >= this.items.length) {
          this.activeTier = i;
          break;
        }
      }
    }
    this.render();
    this.setPanelOpen(true);
    return true;
  };

  Byob.prototype.setPanelOpen = function (open) {
    this.panel.classList.toggle('is-open', open);
    var toggle = this.panel.querySelector('[data-byob-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', open);
  };

  Byob.prototype.removeAt = function (index) {
    this.items.splice(index, 1);
    this.render();
  };

  Byob.prototype.removeLastOf = function (pid) {
    for (var i = this.items.length - 1; i >= 0; i--) {
      if (this.items[i].productId === pid) {
        this.items.splice(i, 1);
        break;
      }
    }
    this.render();
  };

  Byob.prototype.selectTier = function (index) {
    var tier = this.tiers[index];
    if (!tier) return;
    this.activeTier = index;
    if (this.items.length > tier.quantity) this.items = this.items.slice(0, tier.quantity);
    this.render();
  };

  Byob.prototype.variantOf = function (item) {
    var product = this.products[item.productId];
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].id === item.variantId) return product.variants[i];
    }
    return null;
  };

  Byob.prototype.sum = function () {
    var self = this;
    return this.items.reduce(function (acc, it) {
      var v = self.variantOf(it);
      return acc + (v ? v.price : 0);
    }, 0);
  };

  Byob.prototype.matchedTier = function () {
    var n = this.items.length;
    for (var i = 0; i < this.tiers.length; i++) {
      if (this.tiers[i].quantity === n) return this.tiers[i];
    }
    return null;
  };

  Byob.prototype.message = function () {
    var n = this.items.length;
    var tier = this.tier();
    if (!tier) return '';
    var fmt = this.moneyFormat;
    if (n < tier.quantity) {
      return fill(this.data.textMsgRemaining, { remaining: tier.quantity - n, price: formatShort(tier.price, fmt) });
    }
    var next = null;
    for (var i = 0; i < this.tiers.length; i++) {
      if (this.tiers[i].quantity > n) {
        next = this.tiers[i];
        break;
      }
    }
    if (next) return fill(this.data.textMsgNext, { remaining: next.quantity - n, price: formatShort(next.price, fmt) });
    var matched = this.matchedTier() || tier;
    return fill(this.data.textMsgDone, { price: formatShort(matched.price, fmt) });
  };

  Byob.prototype.render = function () {
    var self = this;
    var fmt = this.moneyFormat;
    var tier = this.tier();
    var n = this.items.length;

    this.root.querySelectorAll('[data-byob-tier]').forEach(function (btn) {
      btn.classList.toggle('is-active', parseInt(btn.dataset.byobTier, 10) === self.activeTier);
    });

    this.root.querySelectorAll('[data-byob-card]').forEach(function (card) {
      var pid = parseInt(card.dataset.productId, 10);
      var count = self.countOf(pid);
      var add = card.querySelector('[data-byob-add]');
      var qty = card.querySelector('[data-byob-qty]');
      card.classList.toggle('is-selected', count > 0);
      if (add && qty) {
        add.hidden = count > 0;
        qty.hidden = count === 0;
        card.querySelector('[data-byob-qty-label]').textContent = count;
      }
      var product = self.products[pid];
      var label = card.querySelector('[data-byob-card-variant]');
      if (label && product && product.variants.length > 1) {
        var titles = [];
        self.items.forEach(function (it) {
          if (it.productId !== pid) return;
          var v = self.variantOf(it);
          if (v && titles.indexOf(v.title) === -1) titles.push(v.title);
        });
        label.textContent = titles.join(', ');
      }
    });

    var slotCount = Math.max(tier ? tier.quantity : 0, n);
    var slots = '';
    for (var i = 0; i < slotCount; i++) {
      var item = this.items[i];
      if (item) {
        var product = this.products[item.productId];
        var v = this.variantOf(item);
        var img = (v && v.image) || (product && product.image) || '';
        var alt = product ? product.title.replace(/"/g, '&quot;') : '';
        slots += '<div class="byob-slot">' +
          '<button type="button" class="byob-slot__remove" data-byob-remove="' + i + '" aria-label="Remove">' + ICON_X + '</button>' +
          '<div class="byob-slot__media">' + (img ? '<img src="' + img + '" alt="' + alt + '" loading="lazy">' : '') + '</div>' +
          '</div>';
      } else {
        slots += '<div class="byob-slot byob-slot--empty">' + ICON_PLUS + '</div>';
      }
    }
    this.root.querySelector('[data-byob-slots]').innerHTML = slots;

    var msg = this.message();
    this.root.querySelectorAll('[data-byob-message]').forEach(function (el) {
      el.textContent = msg;
      el.hidden = !msg;
    });

    this.root.querySelector('[data-byob-count]').textContent = n;
    this.root.querySelector('[data-byob-items-label]').textContent = fill(this.data.textItems, { count: n });

    var sum = this.sum();
    var matched = this.matchedTier();
    var total = matched ? matched.price : sum;
    this.root.querySelectorAll('[data-byob-total]').forEach(function (el) {
      el.textContent = formatMoney(total, fmt);
    });
    var compare = this.root.querySelector('[data-byob-compare]');
    if (matched && sum > matched.price) {
      compare.textContent = formatMoney(sum, fmt);
      compare.hidden = false;
    } else {
      compare.hidden = true;
    }
  };

  Byob.prototype.openModal = function (modal) {
    modal.hidden = false;
    document.documentElement.style.overflow = 'hidden';
  };

  Byob.prototype.closeModal = function (modal) {
    if (modal.hidden) return;
    modal.hidden = true;
    if (this.qvModal.hidden && this.vdModal.hidden) document.documentElement.style.overflow = '';
  };

  Byob.prototype.openQuickView = function (pid) {
    var product = this.products[pid];
    if (!product) return;
    this.qvProduct = product;
    this.qvImages = product.images.length ? product.images : [product.image];
    this.qvModal.querySelector('[data-byob-qv-title]').textContent = product.title;
    this.qvModal.querySelector('[data-byob-qv-desc]').innerHTML = product.description || '';
    var qvVariant = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    var qvPrices = this.qvModal.querySelector('[data-byob-qv-prices]');
    var qvCompare = this.qvModal.querySelector('[data-byob-qv-compare]');
    qvPrices.hidden = !qvVariant || this.root.classList.contains('byob--hide-prices');
    if (qvVariant) {
      this.qvModal.querySelector('[data-byob-qv-price]').textContent = formatMoney(qvVariant.price, this.moneyFormat);
      qvCompare.hidden = !(qvVariant.compare > qvVariant.price);
      qvCompare.textContent = qvCompare.hidden ? '' : formatMoney(qvVariant.compare, this.moneyFormat);
    }
    this.qvModal.querySelector('[data-byob-qv-thumbs]').innerHTML = this.qvImages.map(function (src, i) {
      return '<button type="button" class="byob-qv__thumb" data-byob-qv-thumb="' + i + '"><img src="' + src + '" alt="" loading="lazy"></button>';
    }).join('');
    var multi = this.qvImages.length > 1;
    this.qvModal.querySelector('[data-byob-qv-prev]').hidden = !multi;
    this.qvModal.querySelector('[data-byob-qv-next]').hidden = !multi;
    this.showImage(0);
    this.openModal(this.qvModal);
  };

  Byob.prototype.showImage = function (index) {
    var len = this.qvImages.length;
    this.qvIndex = (index + len) % len;
    var img = this.qvModal.querySelector('[data-byob-qv-img]');
    img.src = this.qvImages[this.qvIndex];
    img.alt = this.qvProduct.title;
    var self = this;
    this.qvModal.querySelectorAll('[data-byob-qv-thumb]').forEach(function (el) {
      el.classList.toggle('is-active', parseInt(el.dataset.byobQvThumb, 10) === self.qvIndex);
    });
  };

  Byob.prototype.openVariantDrawer = function (product) {
    this.vdProduct = product;
    var first = product.variants.filter(function (v) { return v.available; })[0] || product.variants[0];
    this.vdSelection = first.options.slice();
    this.vdModal.querySelector('[data-byob-vd-title]').textContent = product.title;
    this.renderVariantOptions();
    this.openModal(this.vdModal);
  };

  Byob.prototype.currentVariant = function () {
    var sel = this.vdSelection;
    var variants = this.vdProduct.variants;
    for (var i = 0; i < variants.length; i++) {
      var match = true;
      for (var j = 0; j < sel.length; j++) {
        if (variants[i].options[j] !== sel[j]) {
          match = false;
          break;
        }
      }
      if (match) return variants[i];
    }
    return null;
  };

  Byob.prototype.renderVariantOptions = function () {
    var self = this;
    var product = this.vdProduct;
    var html = product.options.map(function (name, oi) {
      var isColor = /colou?r|shade/i.test(name);
      var values = product.optionValues[oi] || [];
      return '<div class="byob-option"><div class="byob-option__name">' + name + ': <span>' + self.vdSelection[oi] + '</span></div><div class="byob-option__values">' +
        values.map(function (value) {
          var trial = self.vdSelection.slice();
          trial[oi] = value;
          var variant = null;
          product.variants.forEach(function (v) {
            if (v.options.join('||') === trial.join('||')) variant = v;
          });
          var classes = 'byob-option__value' + (self.vdSelection[oi] === value ? ' is-active' : '') + (!variant || !variant.available ? ' is-unavailable' : '');
          var swatch = '';
          if (isColor) {
            var bg = variant && variant.image ? 'background-image:url(' + variant.image + ')' : 'background-color:' + value.toLowerCase().replace(/\s+/g, '');
            swatch = '<span class="byob-option__swatch" style="' + bg + '"></span>';
          }
          var safe = String(value).replace(/"/g, '&quot;');
          return '<button type="button" class="' + classes + '" data-byob-opt="' + oi + '" data-value="' + safe + '">' + swatch + '<span>' + value + '</span></button>';
        }).join('') + '</div></div>';
    }).join('');
    this.vdModal.querySelector('[data-byob-vd-options]').innerHTML = html;

    var v = this.currentVariant();
    var img = this.vdModal.querySelector('[data-byob-vd-img]');
    img.src = (v && v.image) || product.image || '';
    img.alt = product.title;
    var price = this.vdModal.querySelector('[data-byob-vd-price]');
    price.textContent = v ? formatMoney(v.price, this.moneyFormat) : '';
    price.hidden = this.root.classList.contains('byob--hide-prices');
    var addBtn = this.vdModal.querySelector('[data-byob-vd-add]');
    addBtn.disabled = !v || !v.available;
  };

  Byob.prototype.toast = function (text) {
    if (!this.toastEl || !text) return;
    var el = this.toastEl;
    if (el.parentNode !== document.body) document.body.appendChild(el);
    el.style.setProperty('--byob-font', getComputedStyle(this.root).getPropertyValue('--byob-font'));
    el.textContent = text;
    el.hidden = false;
    clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(function () { el.hidden = true; }, 2500);
  };

  Byob.prototype.rootUrl = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  Byob.prototype.destination = function (code) {
    var base = this.data.cartAction === 'checkout' ? '/checkout' : '/cart';
    if (code) return '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(base);
    return base;
  };

  Byob.prototype.notifyCartUpdated = function () {
    return fetch(this.rootUrl() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.documentElement.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, openMiniCart: true } }));
      })
      .catch(function () {});
  };

  Byob.prototype.openCart = function () {
    return new Promise(function (resolve) {
      setTimeout(function () {
        var link = document.querySelector('#cart-icon-bubble') || document.querySelector('[href="/cart"]');
        if (link) link.click();
        resolve(!!link);
      }, 400);
    });
  };

  Byob.prototype.submit = function () {
    var self = this;
    if (this.busy) return;
    var tier = this.matchedTier();
    if (!this.items.length || (this.tiers.length && !tier)) {
      this.toast(this.message());
      return;
    }

    var bundleLabel = (this.data.bundleName || 'Bundle') + (tier ? ' - ' + fill(this.data.textTierHeading, { quantity: tier.quantity, price: formatShort(tier.price, this.moneyFormat) }) : '');
    var bundleId = Date.now().toString(36);
    var counts = {};
    var order = [];
    this.items.forEach(function (it) {
      if (!counts[it.variantId]) order.push(it.variantId);
      counts[it.variantId] = (counts[it.variantId] || 0) + 1;
    });
    var payload = order.map(function (id) {
      return { id: id, quantity: counts[id], properties: { _bundle: bundleLabel, _bundle_id: bundleId } };
    });

    var code = tier && tier.code ? tier.code : '';
    this.busy = true;
    var cta = this.root.querySelector('[data-byob-submit]');
    cta.classList.add('is-loading');
    if (this.ctaLabelEl) this.ctaLabelEl.textContent = this.data.textAdding;

    function reset() {
      self.busy = false;
      cta.classList.remove('is-loading');
      if (self.ctaLabelEl) self.ctaLabelEl.textContent = self.ctaDefault;
    }

    fetch(this.rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: payload })
    })
      .then(function (r) {
        return r.json().then(function (json) {
          if (!r.ok) throw new Error(json.description || json.message || 'Error');
          return json;
        });
      })
      .then(function () {
        if (!code) return null;
        return fetch(self.rootUrl() + 'discount/' + encodeURIComponent(code), { credentials: 'same-origin' }).catch(function () {});
      })
      .then(function () { return self.notifyCartUpdated(); })
      .then(function () {
        if (self.data.cartAction !== 'drawer') {
          window.location.href = self.destination(code);
          return;
        }
        return self.openCart().then(function (opened) {
          if (!opened) window.location.href = self.destination(code);
          self.items = [];
          self.activeTier = 0;
          self.render();
          reset();
        });
      })
      .catch(function (err) {
        reset();
        self.toast(err && err.message);
      });
  };

  function init(scope) {
    (scope || document).querySelectorAll('[data-byob]').forEach(function (root) {
      if (root._byob) return;
      root._byob = new Byob(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target.querySelector('[data-byob]');
    if (root && root._byob) {
      [root._byob.qvModal, root._byob.vdModal, root._byob.toastEl].forEach(function (el) {
        if (el && el.parentNode === document.body) el.parentNode.removeChild(el);
      });
    }
  });
})();
